import { Box, Container, Typography } from "@mui/material";
import { useLanguage } from "../../i18n/LanguageContext";
import "./plans.css";

const content = {
    en: {
        title: "Packages built around your hotel",
        intro: "Every Smart Key license includes the core platform. Add the modules your property needs, and we will prepare a quote for your hotel.",
        includedTitle: "Included in every license",
        included: [
            "Branded early check-in",
            "AI guest orders by text or voice",
            "Device discovery and provisioning",
            "Housekeeping control and management",
        ],
        addonsTitle: "Optional add-ons",
        addons: [
            "Room access by app, card, watch or parcel (priced per room)",
            "Power-saving sensors",
            "Smart parking",
            "Physical door lock upgrade",
        ],
        stepsTitle: "From first meeting to go-live",
        steps: [
            ["Confirm your license and property scope", ""],
            ["Choose your included modules", "Early check-in, AI orders, provisioning, housekeeping"],
            ["Set guest access methods", "App, card, watch, parcels"],
            ["Define AI and operations workflows", "Orders, alerts, SLAs, KPIs"],
            ["Plan infrastructure and your ROI baseline", "Parking, door locks, power saving"],
        ],
        finalStep: "Sign-off and go-live",
        cta: "Request a quote",
    },
    ar: {
        title: "باقات مصممة حول فندقك",
        intro: "تشمل كل رخصة لضياف المنصة الأساسية، وتضيف إليها الوحدات التي يحتاجها فندقك، ونعدّ لك عرض سعر خاصاً.",
        includedTitle: "مشمول في كل رخصة",
        included: [
            "تسجيل وصول مبكر بهوية فندقك",
            "طلبات الضيوف بالذكاء الاصطناعي نصاً أو صوتاً",
            "اكتشاف الأجهزة وتهيئتها",
            "إدارة التدبير المنزلي والتحكم به",
        ],
        addonsTitle: "إضافات اختيارية",
        addons: [
            "دخول الغرف بالهاتف أو البطاقة أو الساعة أو للطرود (يُسعّر لكل غرفة)",
            "مستشعرات توفير الطاقة",
            "المواقف الذكية",
            "تطوير أقفال الأبواب الحالية",
        ],
        stepsTitle: "من أول اجتماع حتى التشغيل",
        steps: [
            ["تأكيد الرخصة ونطاق المنشأة", ""],
            ["اختيار الوحدات المشمولة", "تسجيل الوصول المبكر، الطلبات الذكية، التهيئة، التدبير المنزلي"],
            ["تحديد طرق دخول الضيوف", "الهاتف، البطاقة، الساعة، الطرود"],
            ["تحديد سير عمل الذكاء الاصطناعي والتشغيل", "الطلبات، التنبيهات، مستويات الخدمة، مؤشرات الأداء"],
            ["تخطيط البنية التحتية وخط الأساس للعائد", "المواقف، أقفال الأبواب، توفير الطاقة"],
        ],
        finalStep: "الاعتماد وبدء التشغيل",
        cta: "اطلب عرض سعر",
    },
};

const check = <path d="m5 12.5 4.5 4.5L19 7.5" />;
const plus = <path d="M12 5v14M5 12h14" />;

const Plans = () => {
    const { lang } = useLanguage();
    const c = content[lang];

    const scrollToContact = () => {
        document.getElementById("contactusSection")?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <>
            <Box className="plansSection" id="plansSection">
                <Container maxWidth="lg">
                    <Typography variant="h3" align="center" gutterBottom>
                        {c.title}
                    </Typography>
                    <Typography variant="subtitle1" align="center" className="plansIntro">
                        {c.intro}
                    </Typography>

                    <Box className="plansColumns">
                        <Box className="plansCard plansIncluded">
                            <Typography variant="h5">{c.includedTitle}</Typography>
                            {c.included.map((item) => (
                                <Box className="plansItem" key={item}>
                                    <svg viewBox="0 0 24 24" aria-hidden="true">{check}</svg>
                                    <Typography>{item}</Typography>
                                </Box>
                            ))}
                        </Box>
                        <Box className="plansCard">
                            <Typography variant="h5">{c.addonsTitle}</Typography>
                            {c.addons.map((item) => (
                                <Box className="plansItem" key={item}>
                                    <svg viewBox="0 0 24 24" aria-hidden="true">{plus}</svg>
                                    <Typography>{item}</Typography>
                                </Box>
                            ))}
                        </Box>
                    </Box>

                    <Typography variant="h4" align="center" className="plansStepsTitle">
                        {c.stepsTitle}
                    </Typography>
                    <Box className="plansSteps">
                        {c.steps.map(([title, detail], index) => (
                            <Box className="plansStep" key={title}>
                                <span>{index + 1}</span>
                                <Typography className="plansStepTitle">{title}</Typography>
                                {detail && <Typography className="plansStepDetail">{detail}</Typography>}
                            </Box>
                        ))}
                        <Box className="plansStep plansStepFinal">
                            <span>
                                <svg viewBox="0 0 24 24" aria-hidden="true">{check}</svg>
                            </span>
                            <Typography className="plansStepTitle">{c.finalStep}</Typography>
                        </Box>
                    </Box>

                    <Box className="plansCta">
                        <button type="button" onClick={scrollToContact}>{c.cta}</button>
                    </Box>
                </Container>
            </Box>
        </>
    )
}
export default Plans;
